import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import GabbroBanner from "../Hamdan Gabbro Qatar/GabbroBanner";

export type GroupPageTab = {
  id: string;
  label: React.ReactNode;
};

type GroupPageShellProps = {
  heroContent?: any;
  tabs: GroupPageTab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
  children: React.ReactNode;
  disableMotion?: boolean;
};

const GroupPageShell: React.FC<GroupPageShellProps> = ({
  heroContent,
  tabs,
  activeTab,
  onTabChange,
  children,
  disableMotion = false,
}) => {
  return (
    <div className="min-h-screen bg-white overflow-hidden">
      <GabbroBanner content={heroContent} />

      <div className="grid grid-cols-2 gap-3 px-4 py-5 md:flex md:flex-wrap md:justify-center md:gap-8">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            onClick={() => onTabChange(tab.id)}
            className={`px-4 py-2 rounded-md font-medium transition-all duration-300 shadow-sm border text-sm flex items-center gap-2 justify-center
              ${activeTab === tab.id
                ? "bg-red-600 text-white border-red-600 shadow-md"
                : "bg-white text-gray-800 border-gray-200 hover:bg-gray-100 hover:shadow-md"
              } w-full sm:w-auto`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="w-full">
        {disableMotion ? (
          <div className="w-full">{children}</div>
        ) : (
          <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.3 }}
            className="w-full"
          >
            {children}
          </motion.div>
          </AnimatePresence>
        )}
      </div>
    </div>
  );
};

export default GroupPageShell;
